<mat-card class="titleBar filter" >
  <div class="all">
      <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
         All <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu class="customPanel" #notification="matMenu">
          <mat-card class="filterOption">
              <div class="fillist">
                  <label>Facility Name</label>
                  <div class="filterlist">                
                    <ng-container >                 
                      <div class="lList"><span class="name" >Green Care</span> </div>   
                      <div class="lList"><span class="name" >Home Care</span> </div>       
                    </ng-container>
                  </div>
              </div>
              <div class="fillist">
                  <label>Saved Filter</label>
                  <div class="filterlist">                
                    <ng-container >                 
                      <div class="lList"><span class="name" >Filter 1</span> </div>   
                      <div class="lList"><span class="name" >Filter 2</span> </div>       
                    </ng-container>
                  </div>
              </div>
          </mat-card>
        </mat-menu>
  </div>
  <div class="quickfilter">
        <mat-form-field appearance="">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="">
          <mat-label>Time</mat-label>
          <input matInput>           
        </mat-form-field>
        <mat-form-field appearance="">
          <mat-label>Duration</mat-label>
          <mat-select>
            <mat-option value="one">1 hr</mat-option>
            <mat-option value="two">2 hr</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="searchField" appearance="">
          <mat-label>Search by Name, Tag & Equipmentt</mat-label>
          <input matInput type="text">
          <!-- <button  mat-icon-button>
            <mat-icon>close</mat-icon>
          </button> -->
        </mat-form-field>
        <button mat-icon-button (click)="openFilter()"  ><mat-icon>filter_list</mat-icon></button>
  </div>
</mat-card>

<!-- 

<table class="table" style="margin-bottom: 100px;" >
  <tr>
      <th class="twidth" >Scheduled at  </th>
      <th class="twidth" > Surgeon</th>
      <th class="twidth" >Patient</th>
      <th style="width=150px">Procedure</th>
      <th  >Tags</th>
      <th  >Status</th>   
      <th  >Action</th>         
  </tr>
  <tr>
    <td>
      <p><b>Date:</b> Mon, Oct 21 </p>
      <p><b>Time:</b> 7:30 AM - 9:30 AM</p>
      <p><b>Duration:</b> 2 hr</p>
    </td>
    <td>MattMcalpin</td>
    <td>Johan Doe <br> 03/11/55, Age 60, M <br> 9897898789</td>
    <td>
      <p><b>Detail:</b> Debridement of wound, burn, or infection</p> 
      <p><b>Description:</b> Debridement of wound, burn, or infection</p>
    </td>
    <td>
      <div class="tagHolder">
      <span class="t1" >TU</span>
      <span class="t2">MK</span>
    </div>
  </td>
  <td>Pending</td>  
  <td>View</td>     
</tr>
</table> -->




<table class="table" >
    <tr>
        <th>Procedure</th>
        <th>Rooms</th>
        <th>Date</th>
        <th>Time</th>
        <th>Duration</th>
        <th>Surgeon</th>
        <th>Anesthesia</th>
        <th>Monitoring</th>
        <th>Case</th>
        <th>Preference Card</th>
        <th>Description</th>
        <th>Tags</th>
        <th>Status</th>
    </tr>
    <tr>
        <td><a href="javascript:(void)" (click)="openCaseDetail()" >Debridement of wound, burn, or infection</a> </td>
        <td><a href="javascript:(void)" (click)="openRoomDetail()" >F1-1</a> </td>
        <td>18 Dec, 20</td>
        <td>6:00 AM - 8 AM</td>
        <td> 2 hr</td>
        <td>M.Mcalpin</td>
        <td>Sr. Johan</td>
        <td>Cardiomo</td>
        <td>  
          <a href="javascript:(void)" (click)="openCoreDetail()" >Wound surgery along …</a>
        </td>
        <td>
          <a href="javascript:(void)" (click)="createFolders(createFolder)" >Mk Surgery</a>
        </td>
        <td>Description</td>
        <td>
          <div class="tagHolder">
            <span class="t1" >TU</span>
            <span class="t2">MK</span>
          </div>
        </td>
        <td>Approved</td>
    </tr>
</table>

<app-core-detail [ngClass]="{'open': showCoreDetail}"  (closeCoreDetail)=getCloseCoreDetail($event) ></app-core-detail>
<app-case-detail [ngClass]="{'open': showCaseDetail}"  (closeCaseDetail)=getCloseCaseDetail($event) ></app-case-detail>
<app-room-detail [ngClass]="{'open': showRoomDetail}" (closeRoomDetail)=getCloseRoomDetail($event) ></app-room-detail>
<app-filter [ngClass]="{'open': showFilter}" (closeFilter)=getCloseFilter($event)  ></app-filter>


<ng-template #createFolder>
  <!-- <h2 matDialogTitle>Create Folder</h2> -->
  <mat-dialog-content>

    <img src="../../../../assets/images/procedureCard.png" alt="" >

  </mat-dialog-content>
  <mat-dialog-actions >
    <button mat-button color="" (click)="close()" >Close</button>
    <!-- <button mat-button color="primary">Create</button> -->
  </mat-dialog-actions>
</ng-template>